<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="title"
    :items="subjectGroups"
    item-value="id"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    @update:search-input="update"
    :loading="loading"
    clearable
  ></v-autocomplete>
</template>

<script>
import { SubjectGroup } from '@/plugins/api'

export default {
  data: () => ({
    subjectGroups: [],
    loading: false,
  }),
  props: {
    filter: Object,
    defaultSubjectGroups: Array,
    options: Object,
  },
  computed: {},
  created() {
    if (this.defaultSubjectGroups) {
      this.subjectGroups = this.defaultSubjectGroups
    }

    this.fetchAllSubjectGroups()
  },
  methods: {
    async fetchAllSubjectGroups() {
      this.loading = true
      this.subjectGroups = await SubjectGroup.fetch({
        ...this.filter,
        _limit: -1,
        _sort: 'index:ASC',
      })
      this.loading = false
    },
    async update() {},
    onChange(data) {
      this.$emit('change', data)
    },
  },
  watch: {
    filter() {
      this.fetchAllSubjectGroups()
    },
  },
}
</script>

<style scoped></style>
